import React from "react";

export default function UploadIcon({ hex }) {
  return (
    <div className="upload-icon">
      <svg viewBox="0 0 105 105" className="upload-icon__svg">
        <path
          className="upload-icon__path"
          style={{ fill: hex, stroke: hex }}
          d="M 25,60
           a 20,20 1 0,0 0,40
           h 50
           a 20,20 1 0,0 0,-40
           a 10,10 1 0,0 -15,-10
           a 15,15 1 0,0 -35,10
           z"
        />
      </svg>
      <div className="upload-icon__container">
        <div className="upload-icon__triangle" />
        <div className="upload-icon__vertical-bar" />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/FeaturedContent/components/UploadIcon.jsx